import {InfoIcon} from '@chakra-ui/icons';
import {HStack, Text} from '@chakra-ui/layout';

/**
 * Panier PDF : Encart d'alerte du récapitulatif d'un panier « Commande PDF » :
 * signale au commercial qu'une information reprise du bon de commande n'a pas pu
 * être matchée avec certitude et mérite vérification avant validation.
 * Rendu dans les blocs date et adresse du récapitulatif.
 */
export const AlerteMatchingPdf: React.FC<{message: string}> = ({message}) => {
  return (
    <HStack
      bg='yellow.warning'
      color='yellow.warning_text'
      borderRadius='8px'
      px='3'
      py='2'
      spacing='2'
      alignItems='start'
    >
      <InfoIcon mt='1' />
      <Text fontSize='sm'>{message}</Text>
    </HStack>
  );
};
